import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../api/order.service';
import { CreateNewModalComponent } from '../../modal/create-new-modal/create-new-modal.component';


@Component({
  selector: 'app-isp-accept-reject',
  templateUrl: './isp-accept-reject.component.html',
  styleUrls: ['./isp-accept-reject.component.scss']
})
export class IspAcceptRejectComponent implements OnInit {
  public status = [];
  public orderId = 0;
  public  orderForm: FormGroup;
  public validationMessages: any;
  public submitted: Boolean = false;
  public isAllReadyAvaiable: boolean;
  public isOrderAvaiable: Boolean = false;
  public orderStatus: any;
  public orderStatusList: any[];
  public modalRef: any;
  public rejectionReasons: any = [ 'Not our area', 'Not Trained', 'No technician available' ];
  public issueType: any = ['DEMO', 'PDI', 'Repair', 'WSR', 'INST', 'Stock'];
  public isRejected: Boolean = false;

  constructor(private http: HttpClient ,
     private formBuilder: FormBuilder ,
     private modalService: NgbModal,
     private router: Router,
     public activeModal: NgbActiveModal,
     private orderService: OrderService
    ) { }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      orderNumber: new FormControl('', Validators.compose([
        Validators.maxLength(9),
        Validators.minLength(5),
        Validators.pattern('^(0|[1-9][0-9]*)$'),
        Validators.required
      ])),
      dateOfCall: ['', Validators.required],
      orderType: ['', Validators.required],
      reasonForRejection: ['']
    });
    this.orderStatusList = [{type: 'Accept'}, {type: 'Reject'} ];

    this.validationMessages = {
      orderNumber: [
        { type: 'required', message: 'Order number is required.' },
        { type: 'minlength', message: 'Order number must be at least 5 digit long.' },
        { type: 'maxlength', message: 'Order number cannot be more than 9 digit long.' },
        { type: 'pattern', message: 'Order number must contain only numbers.' }
      ],
      dateOfCall: [
        { type: 'required', message: 'Date of call is required.' }
      ],
      orderType: [
        { type: 'required', message: 'Order Type is required.' }
      ]
    };
  }

  onRejected() {
    this.isRejected = true;
  }

  checkAndSubmit() {
    if(this.orderForm.value.reasonForRejection) {
      this.checkOrderAcceptOrReject(false);
    }
  }

  checkOrderAcceptOrReject(isAccept) {
    if(this.orderForm.valid) {
      const postData = {
        order_no: this.orderForm.value.orderNumber,
        is_accept: isAccept ? 1 : 0,
        type_of_issue: this.orderForm.value.orderType,
        date_of_call: this.dateConvert(this.orderForm.value.dateOfCall)
      };
      if (!isAccept) {
        postData['reason_for_rejection'] = this.orderForm.value.reasonForRejection
      }
      this.orderService.getOrderAcceptOrReject(postData).subscribe(res => {
        if (res.orderId && res.success && isAccept) {
          this.modalRef = this.modalService.open(CreateNewModalComponent, {
            backdrop: 'static',
            keyboard: false
          });
          this.modalRef.componentInstance.my_modal_content = 'Order Saved With Order Status Accept';
          this.modalRef.result.then((data: any) => {
            this.router.navigate(['/order/add'], {queryParams: {orderNumber: this.orderForm.value.orderNumber}});
          });
        } else {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = 'Order Saved With Order Status Reject';
        }
        this.activeModal.close();
      }, error => {
        if(error.error.error) {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
	        this.modalRef.componentInstance.my_modal_content = error.error.error;
        }
        this.activeModal.close();
      });
    }
  }

  dateConvert(str: string | number | Date) {
    if(typeof(str) == "string") {
      let arr = str.split("/");
      str = arr[1] + "/" + arr[0] + "/" + arr[2];
    }
    const date = new Date(str);
    const mnth = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join('/');
  }
}
